import React from 'react'
import classNames from 'classnames'
import './checkbox.sass'

class Checkbox extends React.Component {
  render() {
    return (
      <div className={classNames('checkbox', { checked: this.props.checked })}>
        <div className="checkbox__switcher">
          <input
            id={this.props.id}
            name={this.props.name}
            onChange={this.props.onChange}
            type="checkbox"
            checked={this.props.checked}
          />
          <div className="checkbox__switch" onClick={this.props.onChange} />
        </div>
      </div>
    )
  }
}

export default Checkbox
